import { useMutation } from "@tanstack/react-query";

import { authClient } from "lib/auth/authClient";
import { reportToSentry } from "lib/sentryErrors";

/**
 * Clears the server-side one-time signup-conversion flag after the webapp has fired the conversion
 * pixels, so they never fire again (see CurrentUserConfiguredProviders + auth-service signup-conversion.ts).
 * Best-effort: a failure only risks the flag surviving, so we report it but don't surface an error.
 */
export function useAcknowledgeSignupConversion() {
  return useMutation({
    mutationFn: async () => {
      // TODO(APP-5979): use a generated, server-typed client instead of this untyped string path.
      const { error } = await authClient.$fetch("/acknowledge-signup-conversion", {
        method: "POST",
      });
      if (error) {
        reportToSentry(error, ["acknowledgeSignupConversion"]);
      }
    },
  });
}
